//* Components
import ShareLink from 'components/common/ShareLink';
import Text from 'components/common/Text';

//* Style
import SharePopupStyle from './style';

const SharePopup = () => {
	return (
		<>
			<SharePopupStyle />

			<div className='share-popup-wrap'>
				<Text
					className={'h3 font-ping-medium share-popup-title text-center'}
					text={'shareProfile'}
				/>

				<Text
					className={'p font-ping-medium share-popup-description text-center'}
					text={'shareDescription'}
				/>

				<ShareLink className='share-popup-links' />
			</div>
		</>
	);
};

export default SharePopup;
